var map = {
	"./PaellaCoreVideoFormats.js": 477,
	"./es.upv.paella.audioVideoFormat.js": 6361,
	"./es.upv.paella.hlsLiveVideoFormat.js": 310,
	"./es.upv.paella.hlsVideoFormat.js": 8069,
	"./es.upv.paella.htmlVideoFormat.js": 8755,
	"./es.upv.paella.imageVideoFormat.js": 4348,
	"./es.upv.paella.mp4VideoFormat.js": 2604
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6189;